
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/masterclasses",
      function () {
        return require("private-next-pages/masterclasses/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/masterclasses"])
      });
    }
  